import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { addAnimationToSprite, PENGUIN_TALKING_ANIMATIONS } from '../AnimationManager';
import staticGameData from '../data/GameData';
import FontKeys from '../FontKeys';
import ResultItem from '../marblemath/ResultItem';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import RoundSelectScreen from './RoundSelectScreen';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class ResultsScreen extends Phaser.Scene {
  static get KEY() { return 'ResultsScreen'; }

  constructor() {
    super({ key: ResultsScreen.KEY });
  }

  init() {
    this.bg = null;
    this.penguin = null;
    this.penguinShadow = null;

    this.resultItems = [];
    this.lblRoundNum = null;
    this.lblScore = null;

    this.btnNext = null;

    this.resultsSound = null;
    this.score = null;
    this.passed = false; // We have different places for next button base on if passed
  }

  create() {
    this.resultItems = [];

    this.bg = this.add.image(0,0,'resultsbackground').setOrigin(0);

    this.penguinShadow = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._mm_assets_RoundSelectPenguinShadow, this).setOrigin(0);

    this.penguin = this.add.sprite(220, 200, ABCyaPhaser.Images.DEFAULT_ATLAS);
    addAnimationToSprite(this.penguin, PENGUIN_TALKING_ANIMATIONS, 'gameIdle', false);
    addAnimationToSprite(this.penguin, PENGUIN_TALKING_ANIMATIONS, 'gameTalking', true);
    this.penguin.scaleX = -1;
    this.penguin.scaleY = 1;

    this.scaleContainer = this.add.container();

    this.resultCircles = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._mm_assets_ResultsCircles, this.scaleContainer).setOrigin(0);
    this.scaleContainer.x = this.scale.width - this.scaleContainer.getBounds().width - 20;

    this.lblRoundNum = ABCyaPhaser.Text.addText(615, 45, 48, 0xffffff, FontKeys._BPreplay_Bold, staticGameData.currentRound, this.scaleContainer, true).setOrigin(0.5, 0);

    const score = Math.floor(this.makeQuestionDisplays());
    this.score = score;
    this.lblScore = ABCyaPhaser.Text.addText(this.resultCircles.width / 2 - 30, 480, 48, 0x2882A5, FontKeys._BPreplay_Bold, `${score}%`, this.scaleContainer, true).setOrigin(0.5, 0);
    this.lblScore.alpha = 0;

    if (score >= 80) {
      this.passed = true;
      this.makeNextLevelButton();
      staticGameData.levelUp();
    }
    else {
      this.passed = false;
      this.makeTryAgainButton();
    }
    this.btnNext.alpha = 0;

    this.layoutRatio();

    this.resultsSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    this.resultsSound.on(Phaser.Sound.Events.COMPLETE, this.stopTalking, this);
    this.resultsSound.on(Phaser.Sound.Events.COMPLETE, this.beginShowingMarks, this);
    ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._Results, this.resultsSound);
  }

  makeQuestionDisplays () {
    const data = staticGameData.getCurrentResults();
    let i; let item; let idata; let answer; let str; let newX; let newY; let isCorrect;
    let totalCorrect = 0;
    const ystart = 120;
    const yoffset = 35;
    const waitTime = 500;
    let maxWidthRow1 = 0;
    let maxWidthRow2 = 0;
    const count = data.length;
    for (i = 0; i < count; i++) {
      idata = data[i];
      answer = idata.num1 + idata.num2;
      str = `${idata.num1} + ${idata.num2} = ${answer}`;

      // str = "15 + 25 = 88";
      newX = i < 5 ? 140 : 325;
      newY = i < 5 ? i * yoffset + ystart : (i - 5) * yoffset + ystart;

      isCorrect = idata.incorrects === 0;
      if (isCorrect) totalCorrect++;
      item = new ResultItem(this, newX, newY, str, isCorrect);
      if (i < 5) {
        maxWidthRow1 = item.getTextWidth() > maxWidthRow1 ? item.getTextWidth() : maxWidthRow1;
      }
      else {
        maxWidthRow2 = item.getTextWidth() > maxWidthRow2 ? item.getTextWidth() : maxWidthRow2;
      }
      this.resultItems.push(item);
      this.scaleContainer.add(item);
    }

    let thisx;
    for (i = 0; i < count; i++) {
      thisx = i < 5 ? maxWidthRow1 : maxWidthRow2;
      this.resultItems[i].setMarkX(thisx);
    }

    const score = totalCorrect === 0 ? 0 : totalCorrect / count * 100;
    return score;
  }

  makeNextLevelButton () {
    this.btnNext = ABCyaPhaser.Images.addImage(650, 450, UIAssetKeys._mm_assets_BtnNextLevel, this).setInteractive()
      .setOrigin(0);
    this.btnNext.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickNext, this);
  }

  clickNext () {
    this.scene.start(RoundSelectScreen.KEY);
  }

  makeTryAgainButton () {
    this.btnNext = ABCyaPhaser.Images.addImage(255, 450, UIAssetKeys._mm_assets_BtnTryAgain, this).setOrigin(0)
      .setInteractive();
    this.btnNext.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickNext, this);
  }

  stopTalking () {
    this.penguin.play('gameIdle');
  }

  beginShowingMarks() {
    const count = this.resultItems.length;
    const waitTime = 450;
    for (let i = 0; i < count; i++) {
      this.resultItems[i].showMark((i + 1) * waitTime);
    }

    this.time.delayedCall(waitTime * (this.resultItems.length + 1), this.showScore, null, this);
  }

  showScore () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._SlideWhistleSound, this);
    ABCyaPhaser.Tweens.addTween(this.lblScore, 600, { alpha: 1 }, Phaser.Math.Easing.Linear, () => this.showNextButton());
  }

  showNextButton () {
    if (this.score >= 80) {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._NextLevelSound, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }
    else {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._TryAgainSound, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }

    ABCyaPhaser.Tweens.addTween(this.btnNext, 400, { alpha: 1 }, Phaser.Math.Easing.Linear);
  }

  layoutRatio () {
    this.penguin.y = this.scale.height - this.penguin.height - 30;
    this.penguinShadow.x = this.penguin.x - this.penguin.width - 75;
    this.penguinShadow.y = this.penguin.y + this.penguin.height - 50;

    this.btnNext.y = this.scale.height - this.btnNext.height - 30;
    if (this.passed) {
      this.btnNext.x = this.scale.width - this.btnNext.width - 20;
    }
    else {
      this.btnNext.x = 255;
    }
  }
}